import axios from "axios";
import {url} from "@/profile/composables/url";

export default {
    install: (app) => {
        app.config.globalProperties.$apipa = {
            value: {
                errors: [],
                data: [],
                success: false,
                error: false,
            },
            async request(params) {
                const {request} =  await axios.post(url, {params: params});
                this.resetStorage();
                let response = JSON.parse(request.response);
                console.log(response);
                if (!response) {
                    this.value.errors.push('Что то пошло не так!');
                    this.value.error = true;
                    return;
                }
                if (response.state === "ERR") {
                    if (response.detailed !== undefined) {
                        this.value.errors.push(response.detailed);
                    }
                    else {
                        this.value.errors.push(response.msg_text);
                    }
                    this.value.error = true;
                }
                if (response.state === "OK") {
                    this.value.data = response;
                    this.value.success = true;
                }
            },
            async get(params) {
                await this.request(params);
                return this.value;
            },
            resetStorage() {
                this.value.errors = [];
                this.value.data = [];
                this.value.success = false;
                this.value.error = false;
            }
        }
    }
}